// Darilni bon — interactive bindings for /products/darilni-bon
// Spec: docs/superpowers/specs/2026-05-15-gift-cards-design.md

(() => {
  const $ = (s) => document.querySelector(s);
  const $$ = (s) => document.querySelectorAll(s);

  const $form = $('#db-product-form');
  if (!$form) return;
  const $variantInput = $('#db-variant-id');
  const $email = $form.querySelector('input[name="properties[Recipient email]"]');
  const $name = $form.querySelector('input[name="properties[Recipient name]"]');
  const $msg = $form.querySelector('textarea[name="properties[Message]"]');
  const $date = $form.querySelector('input[name="properties[Send on]"]');
  const $emailError = $email ? $email.parentElement.querySelector('.gc-field__error') : null;
  const $denoms = $$('.db-denom');
  const $cta = $('#db-cta');
  const $cardAmount = $('#db-gc-amount');
  const $emailSubject = $('#db-p-subject');
  const $emailImage = $('#db-p-image');
  const $trustDelivery = $('#db-trust-delivery');
  const $pTo = $('#db-p-to');
  const $pGreeting = $('#db-p-greeting');
  const $pMsgBlock = $('#db-p-msg-block');

  // Initialize from the Liquid-marked selected button (defaults to 50 €) — falls back to first.
  const $initialSelected = document.querySelector('.db-denom--selected') || $denoms[0];
  let currentAmount = parseInt($initialSelected?.dataset.amount || '50', 10);

  const renderAmount = () => {
    $cta.textContent = `Naroči darilni bon — ${currentAmount} €`;
    $cardAmount.textContent = `${currentAmount} €`;
    // Subject line mirrors Shopify's auto-generated gift card subject: "GUAM kozmetika €50 darilna kartica"
    if ($emailSubject) $emailSubject.textContent = `GUAM kozmetika €${currentAmount} darilna kartica`;
  };

  const renderRecipient = () => {
    if ($pTo) $pTo.textContent = ($email?.value.trim()) || 'ime@example.si';
    const nm = $name?.value.trim();
    // Greeting mirrors notifications/gift_card_notification.liquid email_title logic:
    // if buyer (sender) has a customer record (logged in), use "od osebe X" form;
    // otherwise fall back to "iz trgovine X" with the shop name.
    if ($pGreeting) {
      const sender = (window.dbPreviewSender || '').trim();
      const senderPhrase = sender ? `od osebe ${sender}` : 'iz trgovine GUAM kozmetika';
      $pGreeting.textContent = nm
        ? `Pozdravljeni, ${nm}, prejeli ste darilni bon ${senderPhrase}.`
        : `Pozdravljeni! Prejeli ste darilni bon ${senderPhrase}.`;
    }
    if ($pMsgBlock) {
      while ($pMsgBlock.firstChild) $pMsgBlock.removeChild($pMsgBlock.firstChild);
      const m = $msg?.value.trim();
      if (m) {
        const p = document.createElement('p');
        p.className = 'db-email-msg';
        // Slovenian chevron quotes »...« matching the email template.
        p.textContent = `»${m}«`;
        $pMsgBlock.appendChild(p);
      }
    }
  };

  const renderDelivery = () => {
    if (!$trustDelivery || !$date) return;
    const v = $date.value;
    if (!v) {
      $trustDelivery.textContent = 'Takojšnja e-dostava';
    } else {
      const d = new Date(v);
      const formatted = new Intl.DateTimeFormat('sl-SI', { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
      $trustDelivery.textContent = `Dostava: ${formatted}`;
    }
  };

  $denoms.forEach(btn => {
    btn.addEventListener('click', () => {
      $denoms.forEach(b => { b.classList.remove('db-denom--selected'); b.setAttribute('aria-checked', 'false'); });
      btn.classList.add('db-denom--selected');
      btn.setAttribute('aria-checked', 'true');
      const vid = btn.dataset.variantId;
      if (vid && $variantInput) $variantInput.value = vid;
      currentAmount = parseInt(btn.dataset.amount, 10);
      // Swap the email-preview gift card image to this variant's image.
      const img = btn.dataset.image;
      if (img && $emailImage) $emailImage.src = img;
      renderAmount();
    });
  });

  if ($email && $emailError) {
    const re = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    // `flagEmpty` controls whether an empty value counts as invalid.
    //   While the user is typing, an empty field is benign (they haven't finished yet).
    //   On blur or submit, an empty REQUIRED field is invalid.
    const validate = (flagEmpty = false) => {
      const v = $email.value.trim();
      const empty = v === '';
      const formatInvalid = !empty && !re.test(v);
      const invalid = (flagEmpty && empty) || formatInvalid;
      $email.classList.toggle('gc-field__input--invalid', invalid);
      $emailError.classList.toggle('gc-field__error--hidden', !invalid);
      return !invalid;
    };
    $email.addEventListener('blur', () => validate(true));
    $email.addEventListener('input', () => { validate(false); renderRecipient(); });

    // Block "Naroči darilni bon" submit if the email is empty or invalid —
    // fast feedback instead of round-tripping to Shopify and reloading the page.
    $form.addEventListener('submit', (e) => {
      if (!validate(true)) {
        e.preventDefault();
        $email.focus();
      }
    });
  }

  if ($name) $name.addEventListener('input', renderRecipient);
  if ($msg) $msg.addEventListener('input', renderRecipient);

  if ($date) {
    $date.addEventListener('input', renderDelivery);
    $date.addEventListener('change', renderDelivery);
  }

  renderAmount();
  renderRecipient();
  renderDelivery();
})();
